import React, { useEffect, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { AppGrid } from 'src/components/App';
import { useDashboardStore } from '../../../utils/dashboardStore';
import { ButtonBase, Typography } from '@mui/material';
import { useStyles } from './style';

function SequenceGrid() {
  const classes = useStyles();
  const { fetchSequenceStats, sequenceStats, loading, filters } = useDashboardStore();
  const { data, paging, sort } = sequenceStats;

  const columns = useMemo(
    () => [
      {
        name: 'name',
        label: 'Sequence Name',
        options: {
          sort: true,
          customBodyRenderLite: (dataIndex) => {
            const row = data[dataIndex];
            return (
              <ButtonBase
                onClick={() => {
                  window.open(`/sequence/${row.id}`, '_blank');
                }}
                sx={{ maxWidth: '250px', whiteSpace: 'break-spaces' }}
              >
                <Typography color="secondary" variant="body2" align="left">
                  {row?.name || 0}
                </Typography>
              </ButtonBase>
            );
          },
        },
      },
      {
        name: 'enrolled',
        label: 'Enrolled',
        options: {
          sort: true,
          customBodyRenderLite: (dataIndex) => {
            const row = data[dataIndex];
            return row?.prospectsEnrolled;
          },
          setCellHeaderProps: () => ({ className: classes.centeredHeader }),
          setCellProps: () => ({ className: classes.centeredCell }),
        },
      },
      {
        name: 'contacted',
        label: 'Contacted',
        options: {
          sort: true,
          customBodyRenderLite: (dataIndex) => {
            const row = data[dataIndex];
            return row?.prospectsContacted;
          },
          setCellHeaderProps: () => ({ className: classes.centeredHeader }),
          setCellProps: () => ({ className: classes.centeredCell }),
        },
      },
      {
        name: 'opened',
        label: 'Opened',
        options: {
          sort: true,
          customBodyRenderLite: (dataIndex) => {
            const row = data[dataIndex];
            return row?.prospectsOpened;
          },
          setCellHeaderProps: () => ({ className: classes.centeredHeader }),
          setCellProps: () => ({ className: classes.centeredCell }),
        },
      },
      {
        name: 'clicked',
        label: 'Clicked',
        options: {
          sort: true,
          customBodyRenderLite: (dataIndex) => {
            const row = data[dataIndex];
            return row?.prospectsClicked;
          },
          setCellHeaderProps: () => ({ className: classes.centeredHeader }),
          setCellProps: () => ({ className: classes.centeredCell }),
        },
      },
      {
        name: 'replied',
        label: 'Replied',
        options: {
          sort: true,
          customBodyRenderLite: (dataIndex) => {
            const row = data[dataIndex];
            return row?.prospectsReplied;
          },
          setCellHeaderProps: () => ({ className: classes.centeredHeader }),
          setCellProps: () => ({ className: classes.centeredCell }),
        },
      },
      {
        name: 'interested',
        label: 'Interested',
        options: {
          sort: true,
          customBodyRenderLite: (dataIndex) => {
            const row = data[dataIndex];
            return row?.prospectsInterested;
          },
          setCellHeaderProps: () => ({ className: classes.centeredHeader }),
          setCellProps: () => ({ className: classes.centeredCell }),
        },
      },
    ],
    [data],
  );

  const onSort = (sort) => {
    fetchSequenceStats(paging, sort);
  };

  const handleTableChange = async ({ pageNo, perPage }) => {
    try {
      fetchSequenceStats(
        {
          pageNo,
          perPage,
        },
        sort,
      );
    } catch (error) {}
  };

  useEffect(() => {
    fetchSequenceStats({ perPage: paging?.perPage, pageNo: 0 }, sort);
  }, [filters]);

  return (
    <AppGrid
      skeletonLoading={true}
      onSort={onSort}
      columns={columns.map((col, index) => ({
        ...col,
        options: columns?.columns?.length
          ? { ...col.options, ...columns?.columns[index] }
          : col.options,
      }))}
      onTableChange={handleTableChange}
      data={data}
      loading={loading.sequenceStats}
      options={{
        sortOrder: sort,
        serverSide: true,
        pagination: true,
        page: paging.pageNo,
        rowsPerPage: paging.perPage,
        count: paging.count,
      }}
    />
  );
}

export default SequenceGrid;
